<footer class="footer">
    <div class="footer_top">
        <div class="container">
            <div class="row">
                <div class="col-xl-4 col-md-6 col-lg-4 ">
                    <div class="footer_widget">
                        <div class="footer_logo">
                            <a href="/home">
                                <img src="assets/img/logo.png" alt="">
                            </a>
                        </div>
                        <p>We are focusing on travel lifestyle forthwith and expand our destinations around East Indonesia. We also offer tailor-made travel for Island Expeditions, Research and Adventure. We share our passion for travel and yet, through experience, creativity and commitment. We are your Best Way To Get Around Indonesia. Please don’t hesitate to contact us for your next adventures and let’s wander together to Paradise of East Indonesia. 
                        </p>
                            <ul>
                                <li>
                                    <a href="https://wa.me/6281238310629" target="_blank"> <span> <i aria-hidden="true" class="fab fa-whatsapp"></i> </span>  <span class="icon-list">+62 812-3831-0629 </span> </a>
                                </li>
                                <li>
                                    <a href="https://wa.me/628114340665" target="_blank"> <span> <i aria-hidden="true" class="fab fa-whatsapp"></i> </span>  <span class="icon-list">+62 811-4340-665</span> </a>
                                </li>
                                <li>
                                    <a href="https://mail.google.com/mail/u/0/?view=cm&amp;tf=1&amp;fs=1&amp;to=info@eastindonesiatrip.com" target="_blank"> <span> 
                                    <i aria-hidden="true" class="far fa-envelope"></i> </span> 
                                    <span class="icon-list">info&#64;eastindonesiatrip.com</span> </a>
                                </li>
                            </ul>     
                        
                        <div class="socail_links text-right">
                            <ul>
                                <li>
                                    <a href="https://www.facebook.com/eastindonesiatrip" target="_blank">
                                        <i class="ti-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/eastindonesiatrip/" target="_blank">
                                        <i class="ti-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/@eastindonesiatrip" target="_blank">
                                        <i class="fa-brands fa-youtube"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                <div class="col-xl-4 col-md-6 col-lg-4">
                    <div class="footer_widget">
                        <h3 class="footer_title">
                           Open Trip
                        </h3>
                        <ul class="links">
                            <li>                 
                                <a href="/open-trip-komodo"><i aria-hidden="true" class="fas fa-anchor"></i> 
                                    <span class="icon-list">Komodo National Park </span>
                                </a>
                            </li>
                            <li>
                                <a href="/open-trip-outside-komodo"><i aria-hidden="true" class="fas fa-anchor"></i> 
                                    <span class="icon-list">Outside Komodo (Raja Ampat - Banda Island - Alor)</span>
                                </a>
                            </li>
                        </ul>

                        <h3 class="footer_title">
                            Boats Charter
                         </h3>
                         <ul class="links">
                            <li>                 
                                <a href="/deluxe-boat"><i aria-hidden="true" class="fas fa-anchor"></i> 
                                    <span class="icon-list">Deluxe Boats </span>
                                </a>
                            </li>
                            <li>
                                <a href="/vip-boat"><i aria-hidden="true" class="fas fa-anchor"></i> 
                                    <span class="icon-list">VIP Boats </span>
                                </a>
                            </li>
                            <li>
                                <a href="/vvip-boat"><i aria-hidden="true" class="fas fa-anchor"></i> 
                                    <span class="icon-list">VVIP Boats </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-xl-4 col-md-6 col-lg-4">
                    <div class="footer_widget">
                        <h3 class="footer_title">
                           About Us
                        </h3>
                        <ul class="links">
                            <li>                 
                                <a href="/about-us"><i aria-hidden="true" class="fas fa-info-circle"></i> 
                                    <span class="icon-list">Who we are? </span>
                                </a>
                            </li>
                            <li>
                                <a href="/about-us"><i aria-hidden="true" class="fas fa-info-circle"></i> 
                                    <span class="icon-list">Contact Us </span>
                                </a>
                            </li>
                        </ul>

                         <h3 class="footer_title" style="margin-bottom: 10px!important;">
                            For You Convince, We Accept:
                         </h3>
                         <div class="socail_links" style="margin-top: 0px!important;">
                         <ul>
                            <li>                 
                                <img decoding="async" src="assets/conv/mastercard.svg" alt="mastercard">
                            </li>
                            <li style="padding-left: 15px;">
                                <img decoding="async" src="assets/conv/visa.svg" alt="visa">
                            </li>
                        </ul>
                        </div>
                    </div>
                </div>
      
            </div>
        </div>
    </div>
    <div class="copy-right_text">
        <div class="container">
            <div class="footer_border"></div>
            <div class="row">
                <div class="col-xl-12">
                    <p class="copy_right text-center">
                        <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
Copyright &copy;{{tahun}} East Indonesia Trip All rights reserved
<!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>
